import css from "./Checklist.module.css";

const Checklist = ({ bullets }) => {
  return (
    <ul className={css.main}>
      {bullets?.map((child) => (
        <div className={css.bullet}>
          <img
            className={css.check}
            src="https://storage.googleapis.com/squidslippers-media/icons/check.png"
            alt="check"
          />
          {child}
        </div>
      ))}
    </ul>
  );
};

export default Checklist;
